import { getColoredStyles } from './variantStyles/colored';
import { getColoredNonMandatoryStyles } from './variantStyles/coloredNonMandatory';
import { getNeutralStyles } from './variantStyles/neutral';
import { getNeutralNonMandatoryStyles } from './variantStyles/neutralNonMandatory';
export const getDocReaderStyles = (FOUNDATIONS, FONT) => {
    return {
        // MANDATORY VARIANTS
        ...getNeutralStyles(FOUNDATIONS, FONT),
        ...getColoredStyles(FOUNDATIONS, FONT),
        // NON MANDATORY VARIANTS
        ...getNeutralNonMandatoryStyles(FOUNDATIONS, FONT),
        ...getColoredNonMandatoryStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map